module.exports = __webpack_public_path__ + "img/square_af.fe4af9cc.svg";